import { combineReducers } from 'redux'
import auth from './auth/reducer'
import users from './users/reducer'
import analytics from './analytics/reducer'
import skills from './skills/reducer'
import orders from './orders/reducer'

export default combineReducers({
  auth,
  users,
  analytics,
  skills,
  orders
})



// WEBPACK FOOTER //
// ./src/redux/combineReducers.js